import { useEffect, useRef, useState } from "react";
import { motion, useInView } from "framer-motion";
import { STATS } from "@/content";

function Counter({ to, suffix }) {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-40px" });
  const [val, setVal] = useState(0);

  useEffect(() => {
    if (!inView) return;
    let raf;
    const start = performance.now();
    const dur = 1400;
    const tick = (t) => {
      const p = Math.min(1, (t - start) / dur);
      setVal(Math.round(to * (1 - Math.pow(1 - p, 3))));
      if (p < 1) raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [inView, to]);

  return (
    <span ref={ref} className="gold-text font-serif text-5xl sm:text-6xl leading-none">
      {val}
      {suffix}
    </span>
  );
}

export default function Stats() {
  return (
    <section data-testid="credibility-stats-section" className="bg-[#1B3B2B] border-y border-[#D4AF37]/20">
      <div className="mx-auto max-w-6xl px-5 py-16 lg:py-20">
        <p className="overline-gold text-center mb-10">A Track Record You Can Feel</p>
        <div className="grid grid-cols-2 lg:grid-cols-5 gap-8 lg:gap-4">
          {STATS.map((s, i) => (
            <motion.div
              key={s.label}
              data-testid={`stat-card-${i}`}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.6, delay: i * 0.08 }}
              className="text-center"
            >
              <Counter to={s.value} suffix={s.suffix} />
              <p className="mt-3 text-[11px] uppercase tracking-[0.2em] text-[#D1DDD5]/80 leading-relaxed">
                {s.label}
              </p>
            </motion.div>
          ))}
        </div>
        <p data-testid="oprah-spotlight" className="mt-12 text-center font-serif italic text-lg sm:text-xl text-[#EED88F]/90 max-w-2xl mx-auto">
          “From Oprah's Ultimate Viewers Trip in Australia to the Best Friends Cruise at Half Moon
          Cay — we've lived the journeys we now curate.”
        </p>
      </div>
    </section>
  );
}
